import React from 'react'
import TabLinkUI from '../../../widgets/output/TabLinkUI'

const TermSheetNavUI = ({ loan, tab }) =>
  <div>
    <div className='g_flex_h g_flex_left g_flex_wrap'>
      <TabLinkUI
        label='1. Tokens'
        to={`/su/loans/${loan.loanId}/termSheet`}
        active={tab === 'tokens'}
      />
      <TabLinkUI
        label='2. Document'
        to={`/su/loans/${loan.loanId}/termSheet/schedules`}
        active={tab === 'document'}
      />
      <TabLinkUI
        label='3. Approval'
        to={`/su/loans/${loan.loanId}/termSheet/approval`}
        active={tab === 'approval'}
      />
    </div>
    <div className='g_m_top_50' />
  </div>

export default TermSheetNavUI
